import { api } from "roboflex-thalamus-request-handler";

export default {
  async getPecas(page = 1, perPage = 25, filters = {}) {
    const params = { page, per_page: perPage };
    if (filters.op != null && String(filters.op).trim() !== "") params.op = String(filters.op).trim();
    if (filters.op_cod != null) params.op_cod = filters.op_cod;
    if (filters.produto_cod != null) params.produto_cod = filters.produto_cod;
    if (filters.inconformidade_motivo_id != null) params.inconformidade_motivo_id = filters.inconformidade_motivo_id;

    const response = await api.get("inconformidade/pecas", { params });
    const data = response.data;
    return {
      data: data.data || [],
      pagination: {
        currentPage: data.current_page,
        lastPage: data.last_page,
        perPage: data.per_page,
        total: data.total,
        from: data.from,
        to: data.to,
      },
    };
  },

  async getCategorias() {
    const response = await api.get("inconformidade/categorias");
    return response.data || [];
  },

  async createCategoria(payload) {
    const response = await api.post("inconformidade/categorias", payload);
    return response.data;
  },

  async updateCategoria(id, payload) {
    const response = await api.put(`inconformidade/categorias/${id}`, payload);
    return response.data;
  },

  async deleteCategoria(id) {
    await api.delete(`inconformidade/categorias/${id}`);
  },

  async getMotivos(categoriaIds = null) {
    if (categoriaIds && categoriaIds.length > 0) {
      const response = await api.post("inconformidade/motivos/por-categorias", {
        categoria_ids: categoriaIds,
      });
      return response.data || [];
    }
    const response = await api.get("inconformidade/motivos");
    return response.data || [];
  },

  async createMotivo(payload) {
    const response = await api.post("inconformidade/motivos", payload);
    return response.data;
  },

  async deleteMotivo(id) {
    await api.delete(`inconformidade/motivos/${id}`);
  },

  async getMotivosPorPessoa(pessoaId) {
    const response = await api.post("inconformidade/motivos/por-pessoa", { pessoa_id: pessoaId });
    return response.data || [];
  },

  async getSetoresCategoria(categoriaId) {
    const response = await api.get(`inconformidade/categorias/${categoriaId}/setores`);
    return response.data || [];
  },

  async syncSetoresCategoria(categoriaId, setorIds) {
    const response = await api.put(`inconformidade/categorias/${categoriaId}/setores`, {
      setor_ids: setorIds,
    });
    return response.data || [];
  },

  async getSetoresTodos() {
    const response = await api.get("setor/todos");
    return Array.isArray(response.data) ? response.data : [];
  },

  async getPessoas() {
    const response = await api.get("pessoa");
    return Array.isArray(response.data) ? response.data : [];
  },

  /** Total quantidade de peças inconformes reportadas para uma OP (op_cod). */
  async getTotalQuantidadePorOp(opCod) {
    const response = await api.get("inconformidade/pecas/total-por-op", { params: { op_cod: opCod } });
    return response.data?.total_quantidade ?? 0;
  },

  async updatePeca(id, payload) {
    const response = await api.put(`inconformidade/pecas/${id}`, payload);
    return response.data;
  },

  async deletePeca(id) {
    await api.delete(`inconformidade/pecas/${id}`);
  },
};
